export class ValidationErrorDto {

  public messageCode!: string;
  public errorCode!: string;
  public field!: string;

  constructor(init?: Partial<ValidationErrorDto>) {
    Object.assign(this, init);
  }
}
